<template>
  <layout :title-text="title" class="introduction-container">
    <div slot="content">
      <div class="introduction-content">
        <p>
          <span>“蓝帽杯”全国大学生网络安全技能大赛已连续举办四届，成为面向全国警院的高规格、强影响力的实战技能大赛，被誉为未来网警的“奥运会”。第五届“蓝帽杯”由公安部网络安全保卫局指导，中国人民公安大学、北京理工大学和奇安信科技集团股份有限公司联合主办，北京永信至诚科技股份有限公司为大赛提供平台支持。</span>
          <span>本次比赛在传统CTF赛制的基础上，加入了电子取证、冬奥安保等实战安全场景，通过三方合作覆盖全国警院及高校，增加北部、中西部、东部、南部四大赛区进行区域半决赛，以“三化六防”为指导思想，打造“实战化，体系化，常态化”的网络安全人才培养新机制，为公安系统输送网络安全实战型专业人才。</span>
        </p>
      </div>
    </div>
  </layout>
</template>

<script>
import Layout from '@components/layout'
export default {
  components: {
    Layout
  },
  data () {
    return {
      title: '大赛简介'
    }
  }
}
</script>

<style lang="less" scoped>
.introduction-content {
  position: relative;
  top: -50px;
  width: 1150px;
  background: url(../../assets/images/match-introduction.png) no-repeat center center;
  background-size: contain;
  p {
    padding: 70px 50px;
    font-size: 13px;
    line-height: 24px;
    color:rgba(88, 218, 250, 1);
  }
  span {
    display: block;
    margin-bottom: 10px;
    text-indent: 2em;
    text-align: justify;
  }
}
</style>
